import axiosInst from "api/config/axiosConfig";

export interface DeleteUserTypes {
  delete_useremail: string;
  delete_preferred_username: string;
  proceed_device_transfer: boolean;
}

export enum DeleteUserResponse {
  DevicesRemain,
  Successful,
  NotFound,
  DeletedTransferred,
}

export async function willDeleteUser(data: DeleteUserTypes) {
  const response = await axiosInst.post("/beta/usersTransfer", data);
  return response.data;
}
